import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import DirectDataInputContMain from "presentation/view/container/DirectDataInput/DirectDataInputContMain";

CommonEntrypoint(<DirectDataInputContMain />)